import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FirmOverviewProps {
  title: string;
  description: string;
  highlights: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
}

const FirmOverview: React.FC<FirmOverviewProps> = ({ title, description, highlights }) => {
  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-primary mb-6">
            {title}
          </h2>
          <p className="text-lg text-text-secondary leading-relaxed">
            {description}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {highlights.map((highlight, index) => (
            <div
              key={index}
              className="bg-surface rounded-xl p-8 border border-border hover:shadow-elevation-sm transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-accent to-gold-dark rounded-lg flex items-center justify-center mb-6">
                <Icon name={highlight.icon} size={28} className="text-primary" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-primary mb-3">
                {highlight.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {highlight.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FirmOverview;